import React, { useEffect, useState } from 'react'

import Page from "../../components/Page"
import CourseLaunchSection from '../../components/Course/CourseLaunchSection';
import ModuleDetail from '../modulePages/moduleDetail';
import { useDispatch, useSelector } from 'react-redux';
import { getVideoProductCategories, getProductCategoriesDataClear, getSubProductCategoriesDataClear } from '../../redux/courses/actions';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import VideoCategoryListingSection from '../../components/Video/VideoCategoryListingSection';
//import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';

const VideoCategoriesPage = () => {
    
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
    <Loader start={isLoading} />
    <Page>
     <VideoCategoryListingSection 
      isLoading={isLoading}
      setIsLoading={setIsLoading}
     />
    </Page>
    </>
  )
}

export default VideoCategoriesPage